/**
 * 메뉴 키 → 사이드바가 실제로 보여 주는 라벨.
 *
 * 왜 필요한가: menuRoleManifest 는 관리 UI 표시용 라벨을 문자열로 따로 들고 있었는데,
 * 사이드바는 crmLanguage 의 번역 맵을 거쳐 라벨을 만든다. 두 벌이라 시간이 지나며 갈라졌고,
 * CRM 46개 중 23개가 이름이 달랐다. 예: 사이드바엔 "3D Simulation" 인데 메뉴 관리엔
 * "Digital Twin Sandbox" → 관리자가 "이런 메뉴 없는데?" 하게 된다.
 *
 * 그래서 관리 UI 도 사이드바와 같은 함수를 태운다. 맵에 없는 키는 매니페스트 라벨로
 * 폴백하는데, 이는 사이드바가 코드 label 로 폴백하는 것과 같은 동작이다.
 *
 * ※ 문서자동화(automation) 쪽은 번역 맵 없이 AutomationLayout 의 설정 label 을 그대로
 *   쓰므로 여기서 변환하지 않는다 — 매니페스트 라벨이 곧 그 값이어야 한다.
 */
import type { Language } from "../components/ui/LanguageProvider";
import { getCrmDocumentLabel, getCrmMenuLabel, getCrmSectionLabel } from "../pages/crm/crmLanguage";

/** CRMLayout 의 CRM_SIDEBAR_LANGUAGE 와 같아야 한다 — 사이드바는 영문으로 렌더된다. */
const CRM_SIDEBAR_LANGUAGE = "en" as Language;

export function resolveMenuLabel(menuKey: string, fallback: string): string {
  const parts = menuKey.split(":");
  if (parts[0] !== "crm") return fallback;
  const leaf = parts[parts.length - 1];
  if (parts.length === 2) return getCrmSectionLabel(CRM_SIDEBAR_LANGUAGE, leaf, fallback);
  // 문서 항목은 문서 라벨 맵, 그 밖(extraItems 포함)은 일반 메뉴 라벨 맵을 탄다.
  // 문서 맵에 없으면 일반 맵으로 한 번 더 — 둘 다 없으면 매니페스트 라벨.
  const viaDocument = getCrmDocumentLabel(CRM_SIDEBAR_LANGUAGE, leaf, "");
  if (viaDocument) return viaDocument;
  return getCrmMenuLabel(CRM_SIDEBAR_LANGUAGE, leaf, fallback);
}
